import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import UserCard from "./UserCard";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    padding: 30,
  },
  commentUser: {
    marginTop: "2rem",
    display: "flex",
    justifyContent: "flex-start",
  },
}));

export default function CommentCard({ comment, avatar, person, job }) {
  const classes = useStyles();

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <Typography
          dangerouslySetInnerHTML={{ __html: comment }}
          variant="h3"
          color="secondary"
        ></Typography>
        <div className={classes.commentUser}>
          <UserCard avatar={avatar} person={person} job={job} />
        </div>
      </CardContent>
    </Card>
  );
}
